import { useMemo } from 'react'

import { ContentFiltersContext } from './content-filters.context'
import type { IContentFiltersContext, IContentFiltersProviderProps } from './content-filters.types'
import { buildContentFilters } from './content-filters.utils'

export function ContentFiltersProvider({ territoryIds, loading = false, children }: IContentFiltersProviderProps) {
  const value = useMemo<IContentFiltersContext>(
    () => ({
      territoryIds,
      territoryContentFilters: buildContentFilters(territoryIds),
      loading,
    }),
    [territoryIds, loading]
  )

  return <ContentFiltersContext.Provider value={value}>{children}</ContentFiltersContext.Provider>
}
